import api from './api';

export interface HomeOwnersGuide {
  _id: string;
  workspaceId: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  s3Key: string;
  s3Path: string;
  projects: string[];
  fileUrl?: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export const homeOwnersGuideService = {
  // Get all home owners guides for a workspace
  getAll: async (workspaceId: string): Promise<{ guides: HomeOwnersGuide[] }> => {
    const response = await api.get(`/workspaces/${workspaceId}/home-owners-guides`);
    return response.data;
  },

  // Upload a new home owners guide
  upload: async (
    workspaceId: string,
    file: File,
    projects: string[]
  ): Promise<HomeOwnersGuide> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projects', JSON.stringify(projects));

    const response = await api.post(
      `/workspaces/${workspaceId}/home-owners-guides`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  // Update home owners guide projects
  update: async (
    workspaceId: string,
    guideId: string,
    projects: string[]
  ): Promise<HomeOwnersGuide> => {
    const response = await api.put(
      `/workspaces/${workspaceId}/home-owners-guides/${guideId}`,
      { projects: JSON.stringify(projects) }
    );
    return response.data;
  },

  // Delete home owners guide
  delete: async (workspaceId: string, guideId: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/home-owners-guides/${guideId}`);
  },
};
